export default "__VITE_ASSET__fb5fe5db__"